import { SiKnown } from 'react-icons/si';
import { GiGiftOfKnowledge } from 'react-icons/gi';
import CreateFormTab from './knowledgeBase/CreateFormTab';
import KnowledgeBaseCategoriesFormTab from './knowledgeBaseCategories/KnowledgeBaseCategoriesFormTab';

export const KNOWLEDGE_BASE_DRAWER_TABS = [
  {
    title: 'Knowledge Base',
    icon: <SiKnown size={24} />,
    component: CreateFormTab,
  },
  {
    title: 'Knowledge Base Categories',
    icon: <GiGiftOfKnowledge size={24} />,
    component: KnowledgeBaseCategoriesFormTab,
  },
];
